import { useTranslation } from 'react-i18next';

import { useGetUserLanguage } from '../components/hooks/use-local-storage';

/**
 * Custom hook to detect if the current language requires RTL (right-to-left) text direction
 * Currently supports Hebrew language
 */
export const useRTL = () => {
  const { i18n } = useTranslation();
  const { language: userLanguage } = useGetUserLanguage();

  // Check if current language is Hebrew
  const isHebrew = () => {
    // Check i18n language first
    const currentLang = i18n.language;
    if (currentLang === 'he' || currentLang.startsWith('he-')) {
      return true;
    }

    // Check user language preference
    if (userLanguage === 'Hebrew') {
      return true;
    }

    return false;
  };

  return {
    isRTL: isHebrew(),
    language: i18n.language,
    userLanguage,
  };
};
